import {computed, inject, Injectable, Signal, signal} from "@angular/core";
import {EngagedUserResponse, UsersService} from "@smatchy/sdk";

@Injectable({providedIn: 'root'})
export class UserEngagedStoreService {
  #userApi = inject(UsersService);
  engagedUsers = signal<EngagedUserResponse[]>([]);
  /** Members active over the window before the current one, for growth. */
  previousCount = signal(0);
  countUsers: Signal<number>;
  lastDays = signal(30);

  constructor() {
    this.countUsers = computed(() => this.engagedUsers().length);
    this.getEngagedUsers(this.lastDays());
  }

  getEngagedUsers(countDays: number) {
    this.lastDays.set(countDays);
    this._getEngagedUsers();
  }

  private _getEngagedUsers() {
    this.#userApi.getEngagedUsers({lastDays: this.lastDays()}).subscribe(res => {
      if (res.error) {
        // Alert Error
      } else {
        this.engagedUsers.set(res.value?.users || []);
        // The generated SDK lags behind the API: the field exists on the wire
        // before it exists in the types, hence the local cast.
        const value = res.value as (typeof res.value & { previousCount?: number }) | undefined;
        this.previousCount.set(value?.previousCount ?? 0);
      }

    })
  }
}
